import { useCallback, useEffect, useState } from 'react'

import { get } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { ProductClassesResults } from './types'

const useProductClass = (productId: number) => {
  const [productClasses, setProductClasses] = useState<
    ProductClassesResults | undefined
  >(undefined)
  const [isFetching, setFetching] = useState(false)

  const fetchProductClasses = useCallback(() => {
    setFetching(true)
    return new Promise<ProductClassesResults>((resolve, reject) => {
      get<ProductClassesResults>(`/product_classes/?product=${productId}`)
        .then((data) => {
          resolve(data)
          setProductClasses(data)
          setFetching(false)
        })
        .catch((err) => {
          reject()
          setFetching(false)
          handleApiErrors(err)
        })
    })
  }, [productId])

  useEffect(() => {
    fetchProductClasses()
  }, [fetchProductClasses])

  return { productClasses, isFetching }
}

export default useProductClass
